import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TemplatesPage from './pages/TemplatesPage';
import AssetsPage from './pages/AssetsPage';
import GeneratePage from './pages/GeneratePage';
import JobsPage from './pages/JobsPage';
import TemplateGuidePage from './pages/TemplateGuidePage';
import PipelineResolvePage from './pages/PipelineResolvePage';
import { ensureFirebaseAuth } from './lib/firebase';
import { UnsavedChangesGuardProvider } from './contexts/UnsavedChangesGuardContext';

function App() {
  const [authReady, setAuthReady] = useState(false);
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    ensureFirebaseAuth()
      .then(() => setAuthReady(true))
      .catch((error) => {
        const message = error instanceof Error ? error.message : 'Authentication failed';
        setAuthError(message);
      });
  }, []);

  if (authError) {
    return <div>Firebase authentication failed: {authError}</div>;
  }

  if (!authReady) {
    return <div>Initializing Firebase authentication...</div>;
  }

  return (
    // <Router basename="/template-stamper">
    <UnsavedChangesGuardProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/generate" element={<GeneratePage />} />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/jobs/:jobId" element={<PipelineResolvePage />} />
          <Route path="/template-guide" element={<TemplateGuidePage />} />
        </Routes>
      </Router>
    </UnsavedChangesGuardProvider>
  );
}

export default App;
